<template>
    <loader v-if="options.length === 0" />
    <property-base v-else :label="label" :icon="icon">
        <template #input="{id}">
            <v-select class='form-control'
                      v-model="valueModel"

                      :input-id="id"
                      :options="options"
                      :clearable="false"
                      :disabled="!canWrite"

                      searchable
                      filterable
                      taggable

                      close-on-select
            >
                <div slot='no-options' />
            </v-select>
        </template>
    </property-base>
</template>

<script>
import resources from "@core/Util/Mixins/resources";
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import VSelect from 'vue-select';
import InputGroup from "@core/Components/Inputs/InputGroup";
import PropertyBase from '../SettingsProperty';
import Loader from "@modules/JourneyBuilder/Components/Elements/Loader";

export default {
    name: 'touchpoint-campaign',
    mixins: [permissionsMixin, resources],
    components: {
        VSelect,
        InputGroup,
        PropertyBase,
        Loader
    },
    computed: {
        valueModel: {
            get(){
                if(!this.value){
                    return null;
                }

                return this.options.find(o => o.id === this.value);
            },
            set(value){
                this.$emit('input', value && value.id);
            }
        }
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        value: {
            type: String|Number,
            default: null
        }
    }
};
</script>
